export const IPC = {
  INTERNAL: {
    SYNC_AVAILABLE_RENDERER_IPCS: '@interprocess:syncAvailableRendererIpcs',
  },
}
